<template>
<section class="price-image-section _edit-section">
    <div class="section-inner" v-bind:class="{_display_none: show_preview}">
        <h2 class="heading-section _price-range">Price range<span>(参考上代になります)</span></h2>

        <div class="price-image-card-wrap">
            <div class="inner">

                <!-- Item -->
                <figure class="price-image-card" v-for="(data, key, index) in priceImages" v-bind:key="index">
                    <!-- Image -->
                    <div class="img form_file-img md_no-image">
                        <a class="md_icon-btn _hover delete" v-if="data.image !=='/img/no-image.svg'" @click="deleteImage(key)">
                            <div class="md_svg-icon"><SvgIconDelete /></div>
                        </a>
                        <input type="file" v-bind:id="'price-img' + key" accept="image/*" v-bind:data-preview="'_price-img' + key" v-on:change="changeImage($event, key)">
                        <label v-bind:for="'price-img' + key" class="md_icon-btn _hover">
                            <div class="inner" title="5MB以下"><SvgIconImagePlace /></div>
                        </label>
                        <img class="preview" v-bind:class="'_price-img' + key">
                        <img v-bind:ref="'priceImage' + key" v-bind:src="data.image" alt="">
                    </div>
                    <!-- Detail -->
                    <div class="detail">
                        <!-- Name -->
                        <input type="text" maxlength="250" v-bind:id="'name_' + key" class="edit-pen" v-bind:value="data.name" v-on:input="updateItem">
                        <!-- Price -->
                        <Price :id="'price_' + key" :price="data.price" @update="updatePrice" />
                        <!-- Description -->
                        <textarea class="edit-pen" maxlength="35" v-bind:id="'description_' + key" v-bind:value="data.description" v-on:input="updateItem" placeholder="商品の簡単な説明 最大35文字"></textarea>
                        <!-- Stock -->
                        <div class="stock">
                            <div class="title">在庫の有無</div>
                            <div class="form_checkbox auto-width">
                                <input type="checkbox" :name="'stock' + key" class="" v-bind:id="'stock-' + key" :value="data.stock==true ? 'on': ''" :checked="data.stock == true" @input="updateItem">
                                <label :for="'stock-' + key">
                                    <div class="check-mark">
                                        <span></span>
                                    </div>
                                    <span>在庫あり</span>
                                </label>
                            </div>
                        </div>
                    </div>
                </figure>

            </div>
        </div><!--/.price-image-card-wrap-->

    </div><!--/.section-inner-->
</section>
<ConfirmModalWithPromise ref="confirmModal" />
</template>

<script>
    import SvgIconImagePlace from '@/components/EndUser/svg/SvgIconImagePlace'
    import SvgIconDelete from '@/components/EndUser/svg/SvgIconDelete'
    import Price from '@/components/EndUser/MembershipRegistrationShopStep/Step10Parts/07PriceImageParts/01Price'
    import ConfirmModalWithPromise from '@/components/EndUser/ComponentList/ConfirmModalWithPromise'

    export default {
        components: {
            SvgIconImagePlace,
            SvgIconDelete,
            Price,
            "ConfirmModalWithPromise": ConfirmModalWithPromise,
        },
        data() {
            return {
                imgSrc: '',
                priceImageDatas: {},
            };
        },
        props: {
            priceImages: Object,
            show_preview: Object,
        },
        emits:['updateDatas'],
        methods: {
            changeImage(event, key) {
                const target = event.target;
                const dom = eval('this.$refs.priceImage' + key);
                const rect = dom.getBoundingClientRect();
                const file = event.target.files[0];
                const type = file.type;
                const reader = new FileReader()
                reader.onload = (e) => {
                    this.imgSrc = e.target.result;
                    const imgDatas = {
                        target: target,
                        src: this.imgSrc,
                        type: type,
                        domWidth: rect.width,
                        domHeight: rect.height,
                    }
                this.$emit("openCropper", imgDatas);
                }
                reader.readAsDataURL(file);
                document.getElementById('price-img' + key).value = '';
            },
            async deleteImage(key){
                const confirm = await this.$refs.confirmModal.show({ // 確認済み
                    title: '削除してもよろしいですか？',
                    message: '本当に削除してもよろしいですか？',
                    mode: "delete",
                    name: "confirmModalSubImage"
                })
                if(confirm){
                    this.$emit("deleteImage", key, 'price');
                }
            },
            updatePrice(id, value){
                const newValue = { id, value };
                this.$emit('updateDatas', newValue);
                this.$store.dispatch("getItemData", newValue);
            },
            updateItem(event){
                var value = event.target.value;
                let id = event.target.id;
                if (event.target.id.match(/stock/)) {
                    value = value == "on" ? false : true;
                    const id_array = id.split("-");
                    id = id_array[0] + "-" + value + "_" + id_array[1];
                }
                const newValue = { id, value };
                this.$emit('updateDatas', newValue);
                this.$store.dispatch("getItemData", newValue);
            },
        },
    }
</script>
